import React from "react";

const DeleteIcon = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
  >
    <polygon
      points="18.008,21.551 6.213,21.551 4.657,8.356 5.987,8.198 7.403,20.211 16.801,20.211 18.039,8.208 
        19.371,8.346 "
    />
    <path
      d="M3.755,6.391L3.562,5.066L9.328,4.23c0.366-0.777,1.224-1.782,2.733-1.782c1.505,0,2.378,1.007,2.753,1.783
        l5.624,0.836l-0.196,1.323L13.81,5.435l-0.121-0.412C13.651,4.9,13.275,3.788,12.06,3.788c-1.21,0-1.567,1.104-1.604,1.231
        l-0.121,0.414L9.908,5.498L3.755,6.391z"
    />
    <rect
      x="13.607"
      y="7.973"
      transform="matrix(-0.9996 -0.0292 0.0292 -0.9996 28.1745 25.9329)"
      width="1.339"
      height="9.576"
    />
    <rect
      x="5.024"
      y="12.092"
      transform="matrix(-0.0293 -0.9996 0.9996 -0.0293 -2.6565 22.9427)"
      width="9.575"
      height="1.338"
    />
  </svg>
);

export default DeleteIcon;
